<template>
  <card>
    <slot slot="header">
      <v-toolbar-title>
        <v-icon class="mr-1">vpn_key</v-icon>
        Esqueci minha senha
      </v-toolbar-title>
    </slot>

    <slot slot="body">
      <v-form ref="form">
        <v-container grid-list-lg fluid>
          <v-layout row justify-center align-center wrap>
            <!-- <span v-if="emailSended !== ''">Enviamos um email para {{}}! Confira o email para alterar a senha.</span> -->
            <v-flex xs12>
              <v-alert
                :value="emailSended !== ''"
                type="success"
              >
                Enviamos um email para {{this.emailSended}}! Confira o email para alterar a senha.
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                prepend-icon="person"
                name="login"
                type="text"
                v-model="email"
                :label="translate('table.users.field.email')"
                :rules="requiredRule(translate('table.users.field.email'))"
                @keyup.native.enter="request()"
              />
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-btn dark class="gradient mx-auto" @click="request">Enviar link para redefinir senha</v-btn>
              <v-btn flat href="#/">Voltar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </slot>
  </card>
</template>

<style scoped>
  .gradient {
    background: linear-gradient(40deg, #4a97ce, #5fbf8d);
  }
</style>

<script>
  import Card from '../shared/Card'
  import rules from '../../mixin/rules'

  export default {
    components: {Card},
    mixins: [rules],
    data () {
      return {
        email: '',
        // Para informar o usuário quando o email foi enviado
        emailSended: ''
      }
    },
    methods: {
      request () {
        if (!this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return
        }

        this.$store.commit('loader/change_dialog', true)
        this.$http.post('auth/forgot-password', {email: this.email})
          .then(res => {
            const {color, text} = res.body
            this.emailSended = this.email
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text,
              color,
              dialog: true
            })
          }, er => {
            const {color, text} = er.body

            console.log(er.body)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text,
              color,
              dialog: true
            })
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Forgot.vue